import moment from 'moment-timezone'

/**
 * Compares to moments to see if equal.  Accounts for potential null values,
 * since not all clients send server time.
 * @param {moment} timeA
 * @param {moment} timeB
 * @returns true if equal
 */
export const areTimesEqual = (timeA, timeB) => {
  if (!timeA || !timeB) return timeA === timeB
  if (!moment.isMoment(timeA) && !moment.isMoment(timeB)) return timeA === timeB
  if (!moment.isMoment(timeA) || !moment.isMoment(timeB)) return false
  return timeA.isSame(timeB)
}

/**
 * This is used to handle the case where server time is not being passed in and
 * the caller is relying on the local machine clock.
 * @param {moment} m
 * @returns moment assigned with local time if it's not already a moment
 */
const getLocalTimeIfNecessary = m => (m?.isValid() ? m : moment())

/**
 * Grabs time remaining based on endTime - currentServerTime
 * @param {moment} endTime
 * @param {moment} currentServerTime
 * @returns the difference in ms
 */
export const calcTimeRemaining = (currentServerTime, endTime) =>
  endTime.diff(getLocalTimeIfNecessary(currentServerTime), 'milliseconds')
